import mobxRemotedev from 'mobx-remotedev'
import { makeObservable, observable } from 'mobx'

@mobxRemotedev
export class SingleRecordingStore {
  constructor() {
    makeObservable(this)
  }

  @observable.ref noop: undefined
}
